<template>
  <div class="col-12">
    <b-modal v-model="confirmRemoveModal"
             title="Remover pergunta"
             class="modal-primary"
             @ok="removeFile">
      Deseja remover a empresa #{{ instance.id }} do site? Ao confirmar essa ação a empresa não poderá ser recuperada.
      <br/>
    </b-modal>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <h6 class="col-sm-8 col-xl-10 mb-0">
            {{ instance.title }}
          </h6>
          <div class="col-sm-2 col-xl-1">
            <div class="row">
              <div class="col p-0">
                <router-link :to="{
                  name: 'manageables.edit',
                  params: { entity: 'rte-group-companies', id: instance.id }
                }">
                  <i class="fa fa-edit" v-b-tooltip.hover title="Editar"></i>
                </router-link>
              </div>
              <div class="col p-0 cursor-pointer">
                <i @click.stop.prevent="handleRemove" class="fa fa-trash-o" v-b-tooltip.hover title="Remover"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      instance: {
        type: Object,
        default () {
          return {
            media: []
          }
        }
      },

      http: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        confirmRemoveModal: false
      }
    },

    methods: {
      removeFile () {
        const self = this
        this.$Progress.start()
        self.confirmRemoveModal = false
        self.http.destroy(self.instance.id)
          .then((res) => {
            self.$emit('item-removed', self.instance)
            self.$toasted.success('Empresa removida com sucesso.')
          })
      },

      handleRemove () {
        if (this.instance.id) {
          this.confirmRemoveModal = true
          return null
        }
      }
    }
  }
</script>
<style lang="sass" scoped>
  i.success
    color: #4dbd74
</style>



// WEBPACK FOOTER //
// src/components/forms/Rte/GroupCompanyCard.vue